import React from "react";
import { ComboBox } from "../common/ComboBox";

export interface ICustomAutosuggest<T = { _id: string; name: string }> {
    name?: string;
    className?: string;
    toSuggestionText: (e: T) => string;
    toDisplayText: (e: T) => string;
    values: T[];
    onChange: (e: any) => void;
    selected: T;
    maxListCount?: number;
    placeholder?: string;
    disabled?: boolean;
}

export function CustomAutosuggest<T>({
    name = "autosuggestSearchBox",
    className = null,
    toSuggestionText,
    toDisplayText,
    values,
    selected,
    onChange,
    maxListCount = 50,
    placeholder = "Search",
    disabled = false
}: ICustomAutosuggest<T>): React.ReactElement {
    const getDisplayText = (suggestion: T | string) => {
        if (typeof suggestion == "string") {
            return suggestion;
        }
        if (suggestion && toDisplayText) {
            return toDisplayText(suggestion);
        }
        return "";
    };

    const getSuggestionText = (suggestion: T | string): string => {
        if (typeof suggestion == "string") {
            return suggestion;
        }
        if (suggestion && toSuggestionText) {
            return toSuggestionText(suggestion);
        }
        return "";
    };

    const defaultValue = selected ? (toDisplayText ? toDisplayText(selected) : selected.toString()) : "";

    const options = values.map((value: T) => {
        const name = getDisplayText(value);
        const text = getSuggestionText(value);
        return {
            _id: value["_id"] || name,
            name,
            text
        };
    });

    return (
        <div id={name} className={className}>
            <ComboBox
                options={options}
                defaultValue={defaultValue}
                maxListCount={maxListCount}
                placeholder={placeholder}
                disabled={disabled}
                onOptionSelect={(option) => {
                    if (onChange) {
                        onChange(option || null);
                    }
                }}
            ></ComboBox>
        </div>
    );
}
